const MONITOR_PART_TYPE = {
  Monitor: 'monitor',
  MonitorScreen: 'monitor_screen',
  MonitorArmMountBase: 'monitor_arm_mount_base',
  MonitorArmMountArm01: 'monitor_arm_mount_arm01',
  MonitorArmMountArm02: 'monitor_arm_mount_arm02',
  MonitorScreenCloseIcon: 'monitor_screen_close_icon',
  MonitorScreenVolume: 'monitor_screen_volume',
  MonitorCloseFocusIcon: 'monitor_close_focus_icon',
}

const MONITOR_PART_ACTIVITY_CONFIG = {
  [MONITOR_PART_TYPE.Monitor]: true,
  [MONITOR_PART_TYPE.MonitorScreen]: true,
  [MONITOR_PART_TYPE.MonitorArmMountBase]: true,
  [MONITOR_PART_TYPE.MonitorArmMountArm01]: true,
  [MONITOR_PART_TYPE.MonitorArmMountArm02]: true,
  [MONITOR_PART_TYPE.MonitorScreenCloseIcon]: true,
  [MONITOR_PART_TYPE.MonitorScreenVolume]: true,
  [MONITOR_PART_TYPE.MonitorCloseFocusIcon]: true,
}

const MONITOR_PARTS_WITHOUT_BUTTONS = [
  MONITOR_PART_TYPE.Monitor,
  MONITOR_PART_TYPE.MonitorArmMountBase,
  MONITOR_PART_TYPE.MonitorArmMountArm01,
  MONITOR_PART_TYPE.MonitorArmMountArm02,
]

const MONITOR_SCREEN_BUTTONS = [
  MONITOR_PART_TYPE.MonitorScreenCloseIcon,
]

export { 
  MONITOR_PART_TYPE, 
  MONITOR_PART_ACTIVITY_CONFIG, 
  MONITOR_SCREEN_BUTTONS, 
  MONITOR_PARTS_WITHOUT_BUTTONS, 
}
